import { Redirect, useParams } from "react-router-dom";
import { useQualifiedInvoiceBusinessIssuersIndexHooks } from "../../../../organisms/smart-apply/qualified-invoice/business-issuers/hooks";
import {
  InformationBanner,
  PrimaryButton,
  Spinner,
} from "@graffer-inc/console-design-kit";
import { QualifiedInvoiceBusinessIssuersTable } from "../../../../organisms/smart-apply/qualified-invoice/business-issuers/table";
import { useAuthContextV2 } from "../../../../../auth-state";
import { ServiceProviderR } from "../../routes";

export const QualifiedInvoiceBusinessIssuersIndex: React.FC = () => {
  const authContext = useAuthContextV2();

  const { id: orgId } = useParams<{ id: string }>();

  const {
    enablePayment,
    redirectTo,
    isLoading,
    editTargetId,
    businessIssuers,
    handleOnSetRedirectToNew,
    handleOnSetRedirectToEdit,
  } = useQualifiedInvoiceBusinessIssuersIndexHooks({
    orgId,
    auth: authContext.auth,
  });

  if (!authContext.auth.hasPermissions("invoice_business_issuers.create")) {
    return <></>;
  }

  if (redirectTo === "new") {
    return (
      <Redirect
        to={ServiceProviderR.QualifiedInvoiceBusinessIssuersNew.link({
          id: orgId,
        })}
      />
    );
  }

  if (redirectTo === "edit") {
    return (
      <Redirect
        to={ServiceProviderR.QualifiedInvoiceBusinessIssuersEdit.link({
          id: orgId,
          businessIssuerId: editTargetId,
        })}
      />
    );
  }

  return (
    <div>
      <h3
        className="title is-size-4 mt-6 mb-4 pl-2"
        style={{
          borderLeft: "6px solid #40bfb0",
        }}
      >
        適格請求書発行事業者
      </h3>
      <div className="column">
        <nav className="level">
          <div className="level-left"></div>
          <div className="level-right">
            <p className="level-item">
              <PrimaryButton
                text={"新規登録"}
                disabled={!enablePayment}
                onClick={handleOnSetRedirectToNew}
              />
            </p>
          </div>
        </nav>
        <Spinner loading={isLoading} />
        {enablePayment ? (
          <>
            {businessIssuers.length === 0 && (
              <InformationBanner message="適格請求書発行事業者が登録されていません。" />
            )}
            {businessIssuers.length > 0 && (
              <QualifiedInvoiceBusinessIssuersTable
                businessIssuers={businessIssuers}
                handleOnEdit={handleOnSetRedirectToEdit}
              />
            )}
          </>
        ) : (
          <InformationBanner message="決済設定が無効のため、適格請求書発行事業者の登録ができません。" />
        )}
      </div>
    </div>
  );
};
